import { api } from './api-core';


export const MyCourse = {
    getMyCourse: (page: string, pageSize: string, search?: string) => {
        let url = `${process.env.API_GET_MY_COURSE}?page=${page}&pageSize=${pageSize}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getCompletedActivities: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_ACTIVITY_COMPLETE}?page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDueActivities: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_ACTIVITY_DUE}?page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
}